import { ConfigurationService } from './../configuration/configuration.service';
import { Injectable } from '@angular/core';
declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor(private configurationService: ConfigurationService) {
    const GOOGLE_ANALYTICS_ID = this.configurationService.config.GOOGLE_ANALYTICS_ID;
    console.log('Google Analytics ID:', GOOGLE_ANALYTICS_ID);
    gtag('js', new Date());
    gtag('config', GOOGLE_ANALYTICS_ID);
  }

  public pageView(url: string, matchedRoute: string) {
    gtag('event', 'page_view', {
      page_path: url,
      matched_route: matchedRoute,
    });
  }
}
